import { LwApiPM } from "@techniaorg/liteweb-api";
import { waitForIFrameAndModel } from "../src/util";

// Wait until the iframe is loaded
const myframe = document.querySelector("iframe#webviewer") as HTMLIFrameElement;
let LwAPI: LwApiPM | null = null;
const apiReady: Promise<LwApiPM | null> = waitForIFrameAndModel(myframe)
  .then((api) => {
    LwAPI = api;
    return api;
  })
  .catch((e) => {
    console.log("LwAPI could not be initialized: ", e);
    return null;
  });

function ex_addpoints(modelUrl: string) {
  var coords = [
    130, 20, 20, 70, -20, 30, -40, -20, 30, 50, -90, 28.4, 70, 20, 0,
  ];

  var ids = ["point1", "point2", "point3", "point4", "point5"];

  var color = [1, 0, 0];
  var radius = 3.0;

  LwAPI?.addPoints(coords, color[0], color[1], color[2], radius, ids, modelUrl);
}

function ex_addpoints2(modelUrl: string) {
  //LwAPI.addPoints([130, 20, 60, 70, -20, 70, -40, -20, 70, 50, -90, 68.4, 70, 20, 40,], 0, 0, 1, 4.0, ["point6", "point7", "point8", "point9", "point10"]);
  var coords = [
    130, 20, 60, 70, -20, 70, -40, -20, 70, 50, -90, 68.4, 70, 20, 40,
  ];

  var ids = ["point6", "point7", "point8", "point9", "point10"];

  var color = [0, 0, 1];
  var radius = 4.0;

  LwAPI?.addPoints(coords, color[0], color[1], color[2], radius, ids, modelUrl);
}

function ex_regsel() {
  LwAPI?.registerOnSelection(function (selectedItem) {
    if (selectedItem != null) {
      (document.getElementById("output") as HTMLTextAreaElement).value =
        JSON.stringify(selectedItem, null, 2);
    }
  });
}

function ex_setsel() {
  LwAPI?.setNodeSelection("point3", true);
}

function ex_unsetsel() {
  LwAPI?.setNodeSelection("point3", false);
}

// Bind functions to buttons
document.getElementById("addpoints")?.addEventListener("click", async () => {
  await apiReady;
  ex_addpoints("Measurement.jt");
});
document.getElementById("addpoints2")?.addEventListener("click", async () => {
  await apiReady;
  ex_addpoints2("Measurement.jt");
});
document.getElementById("regsel")?.addEventListener("click", async () => {
  await apiReady;
  ex_regsel();
});
document.getElementById("setsel")?.addEventListener("click", async () => {
  await apiReady;
  ex_setsel();
});
document.getElementById("unsetsel")?.addEventListener("click", async () => {
  await apiReady;
  ex_unsetsel();
});
